<template>
  <div :class="$style.wrap">
    <ul :class="$style.contents">
      <li v-for="breadcrumb in page.breadcrumbs.list" :key="breadcrumb">
        <router-link :to="breadcrumb.link" @click="onCrumbClick">{{ breadcrumb.label }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'breadcrumbs',
  computed: {
    ...mapState(['page']),

    /**
     * 中間クラムを持つ（＝ホーム > 一覧タブ > 詳細 と階層が一意に決まる）画面か。
     * 現状これに該当するのは各ロールの相談詳細のみ。
     */
    hasParentCrumb() {
      const list = this.page.breadcrumbs.list;
      return list.length >= 3 && !!list[1] && !!list[1].link && !!list[1].label;
    },
  },
  methods: {
    /**
     * 階層が一意に決まる画面に限り、タブ復帰状態（LS の saveState）を捨てて
     * 「TOP」を本当のホームへ着地させる。中間クラムでその一覧タブへ戻れるので導線は失われない。
     * 中間クラムを持たない画面は複数のタブから開けるため（例: 相談履歴は 5 つのタブから流入）、
     * 上の階層を一意に決められない。そちらは従来どおり元のタブへ復帰させる。
     */
    onCrumbClick() {
      if (this.hasParentCrumb) cf.deleteTabState();
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  position: fixed;
  top: var(--header-height);
  width: 100%;
  background-color: var(--gray-sub);
  padding: 0 20px;
  height: 50px;
  z-index: 2;
}
.contents {
  display: flex;
  align-items: center;
  height: 100%;
  li {
    font-size: 12px;
    a {
      color: var(--black);
    }
    &:not(:last-child) {
      &::after {
        content: '>';
        margin: 0 13px;
      }
    }
    &:last-child {
      a {
        pointer-events: none;
      }
    }
  }
}
</style>
